import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import { PriceRange } from "./price-range";
import { FilterCollapse } from "../filter-collapse";

export const PriceFilters = () => {
  const { translator, features } = useAppContext();

  if (!features.RESULTS_FILTERS_MAX_PRICE) {
    return null;
  }

  return (
    <FilterCollapse title={translator.t("!results.filters.price")}>
      <PriceRange />
    </FilterCollapse>
  );
};
